<template>
    <div class="home-page index-page">
      <header class="index-header"><a href="/"><img src="../../static/images/logo1.png" alt="WowBox" /></a></header>
      <main class="index-main">
        <div class="claim-banner" @click="goTrafficRewardList">
          <img src="../../static/images/claim/gitf_pack_baner.png" alt="30MB" />
        </div>

        <section class="quiz-section">
          <div v-if="hasQuestion" class="quiz-card">
            <div class="quiz-picture"><img :src="question.image" alt="" /></div>
            <div class="quiz-title">{{question.title}}</div>
            <div class="quiz-answers">
              <button v-for="(item,key) in question.answer" :key="key" type="button" class="quiz-answer" :class="{'active':answerT==key}" @click="answerClick(key)">{{item}}</button>
            </div>
            <div class="quiz-check-row">
              <img class="quiz-scroll-arrow" src="../../static/images/index/scroll_down_arrow.png" alt="" />
              <button type="button" class="quiz-check" @click="getAnswer()"><span class="quiz-check-label">{{$t('homeLetsCheck')}}<img src="../../static/images/index/check_arrow.png" alt="" /></span></button>
              <img class="quiz-scroll-arrow" src="../../static/images/index/scroll_down_arrow.png" alt="" />
            </div>
          </div>
          <div class="index-summary">
            <div class="summary-count"><span>{{$t('homeQuestionsLeft')}}</span><strong>{{left_qus_num}}</strong></div>
            <button type="button" class="summary-link" @click="openBuyQuestions"><span>{{$t('homeMoreQuestions')}}</span><img src="../../static/images/index/plus.png" alt="" /></button>
          </div>
        </section>

        <section ref="lotterySection" class="lottery-section">
          <div class="lottery-board">
            <img v-if="$i18n.locale === 'en'" class="lottery-heading" src="../../static/images/index/lucky_boxes_txt.png" :alt="$t('homeLuckyBoxes')" />
            <div v-else class="lottery-heading lottery-heading-text">{{$t('homeLuckyBoxes')}}</div>
            <div class="lottery-description"><span>{{$t('homeLuckyDescription')}}</span><br /><strong>{{$t('homeAmazingRewards')}}</strong></div>
            <div class="lottery-grid">
              <div class="lottery-item" v-for="index in 9" :key="index">
                <button class="lottery-box" type="button" @click="goPlay()"><img src="../../static/images/index/box.png" alt="" /></button>
                <button class="lottery-pick" type="button" @click="goPlay()"><span>{{$t('homePick')}}</span></button>
              </div>
            </div>
            <button class="lottery-random" type="button" @click="goPlay(1)"><span>{{$t('homeRandomPick')}}</span></button>
          </div>
          <div class="index-summary lottery-summary">
            <div class="summary-count"><span>{{$t('homeGiftBoxesLeft')}}</span><strong>{{draw_num}}</strong></div>
            <button type="button" class="summary-link" @click="$router.push({path:'/luckyDraw'})"><span>{{$t('homeViewAllPrizes')}}</span><img src="../../static/images/index/view_all_prizes.png" alt="" /></button>
          </div>
        </section>
      </main>
      <HomeTabBar active="boxes" :available="hasAvailableBoxes" @select-box="scrollToLottery" />
      <div class="modal defModal" v-if="isShow">
        <div class="modal-bg" style="background: rgba(0,0,0,.2);"></div>
        <div class="modal-content" style="width: 100%;margin-left: -50%;">
          <div class="modal-content2">
            <img width="" src="../../static/images/prize.gif" />
          </div>
        </div>
      </div>
      <div v-if="showAnswerResult" class="answer-result-overlay" :class="{'answer-result-burmese':$i18n.locale !== 'en'}" role="dialog" aria-modal="true" :aria-label="$t(answerReson.is_correct == 1 ? 'answerCorrectTitle' : 'answerWrongTitle')">
        <div class="answer-result-mask"></div>
        <div class="answer-result-layout">
          <div class="answer-result-panel">
            <img v-if="answerReson.is_correct == 1" class="answer-result-art" src="../../static/images/answer_pop_up/got_2_box.png" alt="" />
            <img v-else class="answer-result-art" src="../../static/images/answer_pop_up/got_1_box.png" alt="" />
            <div class="answer-result-title">
              <span>{{$t(answerReson.is_correct == 1 ? 'answerCorrectTitle' : 'answerWrongTitle')}}</span>
            </div>
            <div class="answer-result-details">
              <p>{{$t('answerYourAnswerIs')}} <strong :class="answerReson.is_correct == 1 ? 'answer-correct' : 'answer-wrong'">{{$t(answerReson.is_correct == 1 ? 'answerCorrectWord' : 'answerWrongWord')}}</strong></p>
              <p>{{$t('answerYouGot')}} <em>{{answerReson.num}}</em> {{$t('answerLuckyBoxes')}}</p>
              <button type="button" class="answer-result-confirm" @click="answerModal"><span>{{$t(answerReson.is_correct == 1 ? 'answerConfirmCorrect' : 'answerConfirmWrong')}}</span></button>
            </div>
          </div>
          <button type="button" class="answer-result-close" @click="answerModal" :aria-label="$t('answerClose')"><img src="../../static/images/answer_pop_up/close.png" alt="" /></button>
        </div>
      </div>
      <div v-if="showPrizeResult" class="answer-result-overlay prize-result-overlay" :class="{'prize-result-burmese':$i18n.locale !== 'en'}" role="dialog" aria-modal="true" :aria-label="$t('prizeOpenBoxTitle')">
        <div class="answer-result-mask"></div>
        <div class="answer-result-layout">
          <div class="prize-result-panel">
            <img class="prize-result-art" src="../../static/images/prize_pop_up/open_box.png" alt="" />
            <div class="answer-result-title prize-result-title"><span>{{$t('prizeOpenBoxTitle')}}</span></div>
            <div class="prize-result-details">
              <p>{{$t('prizeOpenedPrefix')}} <strong>{{$t('prizeLuckyBox')}}</strong><br />{{$t('prizeReceived')}}</p>
              <div class="prize-result-reward" :class="{'prize-result-empty':!hasWonPrize}">
                <span v-if="!hasWonPrize">{{$t('prizeThankYou')}}</span>
                <template v-else><span v-for="(item,index) in modalList.list" :key="index">{{item.name}}</span></template>
              </div>
              <button type="button" class="answer-result-confirm prize-result-confirm" @click="saveModal"><span>{{$t(hasWonPrize ? 'prizeClaimReward' : 'prizeOk')}}</span></button>
            </div>
          </div>
          <button type="button" class="answer-result-close" @click="saveModal" :aria-label="$t('prizeClose')"><img src="../../static/images/prize_pop_up/close.png" alt="" /></button>
        </div>
      </div>
      <div v-if="showBuyQuestions" class="answer-result-overlay buy-popup-overlay" :class="{'buy-popup-burmese':$i18n.locale !== 'en'}" role="dialog" aria-modal="true" :aria-label="$t('buyPopupTitle')">
        <div class="answer-result-mask"></div>
        <div class="answer-result-layout">
          <div class="buy-popup-panel">
            <img class="buy-popup-art" src="../../static/images/buy_pop_up/buy_more_question.png" alt="" />
            <div class="answer-result-title buy-popup-title"><span>{{$t('buyPopupTitle')}}</span></div>
            <div class="buy-popup-details">
              <p>{{$t('buyPopupNeedMore')}}</p>
              <p>{{$t('buyPopupGet')}} <strong>{{$t('buyPopupExtraQuestions')}}</strong> {{$t('buyPopupAnd')}}</p>
              <p>{{$t('buyPopupKeepFun')}}</p>
              <button type="button" class="answer-result-confirm buy-popup-confirm" :disabled="sendingBuyOtp" @click="getSendOtp"><span>{{$t('buyPopupPrice')}}</span></button>
            </div>
          </div>
          <button type="button" class="answer-result-close" @click="closeBuyPopup" :aria-label="$t('buyPopupClose')"><img src="../../static/images/buy_pop_up/close.png" alt="" /></button>
        </div>
      </div>
      <div v-if="showBuyOtp" class="answer-result-overlay buy-popup-overlay" :class="{'buy-popup-burmese':$i18n.locale !== 'en'}" role="dialog" aria-modal="true" :aria-label="$t('buyOtpTitle')">
        <div class="answer-result-mask"></div>
        <div class="answer-result-layout">
          <div class="buy-popup-panel buy-otp-panel">
            <img class="buy-popup-art" src="../../static/images/buy_pop_up/otp_pic.png" alt="" />
            <div class="answer-result-title buy-popup-title"><span>{{$t('buyOtpTitle')}}</span></div>
            <div class="buy-otp-details">
              <p>{{$t('buyOtpPleaseEnter')}} <strong>{{$t('buyOtpCode')}}</strong> {{$t('buyOtpCodeSuffix')}}<br />{{$t('buyOtpContinue')}}</p>
              <div class="buy-otp-field">
                <input v-model="buyOtp" type="tel" inputmode="numeric" autocomplete="one-time-code" placeholder="------" :aria-label="$t('enterOtp')" />
                <span v-if="buyOtpSeconds > 0" class="buy-otp-seconds">{{buyOtpSeconds}}s</span>
                <button v-else type="button" class="buy-otp-resend" :disabled="sendingBuyOtp" :aria-label="$t('ResendOTP')" @click="getSendOtp"><img src="../../static/images/buy_pop_up/resend_btn_bg.png" alt="" /></button>
              </div>
              <button type="button" class="answer-result-confirm buy-popup-confirm buy-otp-confirm" :disabled="verifyingBuyOtp" @click="getBuy"><span>{{$t('buyOtpConfirm')}}</span></button>
            </div>
          </div>
          <button type="button" class="answer-result-close" @click="closeBuyPopup" :aria-label="$t('buyPopupClose')"><img src="../../static/images/buy_pop_up/close.png" alt="" /></button>
        </div>
      </div>
      <div class="modal claim-reward-modal" v-if="showTrafficRewardDialog">
        <div class="modal-bg"></div>
        <div class="claim-reward-panel">
          <img class="claim-reward-panel-bg" src="../../static/images/claim/pop_up_bg.png" />
          <div class="claim-reward-copy">
            <img src="../../static/images/claim/text_bg.png" />
            <p>{{$t('claimRewardMessage')}}</p>
          </div>
          <button class="claim-reward-action" @click="goTrafficRewardList">
            <img src="../../static/images/claim/claim_btn.png" />
            <span>{{$t('claimNow')}}</span>
          </button>
          <button class="claim-reward-close" @click="closeTrafficReward" :aria-label="$t('claimClose')">
            <img src="../../static/images/claim/close.png" />
          </button>
        </div>
      </div>

	</div>
</template>
<script>
import HomeTabBar from '../components/HomeTabBar'
export default {
    components:{
		HomeTabBar
    },
    data() {
      return {
        isShow:false,
        modalList:{
          'list':[],
        },
        showPrizeResult:false,
        draw_num:'',
        left_qus_num:'',
        answerT:'',
        question:{},
        answerReson:{},
        showAnswerResult:false,
        showBuyQuestions:false,
        showBuyOtp:false,
        buyOtp:'',
        buyOtpSeconds:0,
        buyOtpTimer:null,
        sendingBuyOtp:false,
        verifyingBuyOtp:false,
        showTrafficRewardDialog:false
      }
    },
	computed:{
      hasQuestion(){
        return !!(this.question && this.question.id && this.question.answer)
      },
      hasAvailableBoxes(){
        return Number(this.draw_num) > 0
      },
      hasWonPrize(){
        return Array.isArray(this.modalList.list) && this.modalList.list.length > 0
      }
	},
	created(){
    // 奖励走马灯已隐藏，不请求 /api/index/scroll_light。
    if (this.$route.query.mobile){
      this.fastLogin();
    }else {
      this.getHome();
      this.getTrafficRewards();
    }
	},
  beforeDestroy(){
    if (this.buyOtpTimer) clearInterval(this.buyOtpTimer)
  },
    methods: {
      scrollToLottery(){
        if (this.$refs.lotterySection) {
          this.$refs.lotterySection.scrollIntoView({behavior:'smooth',block:'start'})
        }
      },
      openBuyQuestions(){
        this.showBuyQuestions = true
      },
      closeBuyPopup(){
        this.showBuyQuestions = false
        this.showBuyOtp = false
        this.buyOtp = ''
      },
      getSendOtp(){
        if (this.sendingBuyOtp) return
        if (this.buyOtpSeconds > 0) {
          this.showBuyQuestions = false
          this.showBuyOtp = true
          return
        }
        this.sendingBuyOtp = true
        this.$api.post('/api/user/send_otp',null,r => {
          this.sendingBuyOtp = false
          this.$parent.returnCode(r,() => {
            const shouldShowOtp = this.showBuyQuestions || this.showBuyOtp
            this.showBuyQuestions = false
            this.showBuyOtp = shouldShowOtp
            this.buyOtp = ''
            this.$utils.alertText(r.msg,80,3000)
            this.startBuyOtpCountdown()
          })
        })
      },
      startBuyOtpCountdown(){
        if (this.buyOtpTimer) clearInterval(this.buyOtpTimer)
        this.buyOtpSeconds = 60
        this.buyOtpTimer = setInterval(() => {
          this.buyOtpSeconds--
          if (this.buyOtpSeconds <= 0) {
            clearInterval(this.buyOtpTimer)
            this.buyOtpTimer = null
          }
        },1000)
      },
      getBuy(){
        if (this.verifyingBuyOtp) return
        if (!this.buyOtp.trim()) {
          this.$utils.alertText(this.$t('enterOtp'),80,3000)
          return
        }
        this.verifyingBuyOtp = true
        this.$parent.loadModal(true)
        this.$api.post('/api/user/verify_otp',{otp:this.buyOtp.trim()},r => {
          this.verifyingBuyOtp = false
          this.$parent.loadModal(false)
          this.$utils.alertText(r.msg,80,3000)
          if (Number(r.code) === 1) {
            if (this.buyOtpTimer) clearInterval(this.buyOtpTimer)
            this.buyOtpTimer = null
            this.buyOtpSeconds = 0
            this.closeBuyPopup()
            this.getHome()
          }
        })
      },
      answerClick(item){
        this.answerT = item
      },
      getAnswer(){
        let that = this
        let data = {
          question_id:that.question.id,
          user_answer:that.answerT
        }
        that.$api.post('/api/index/answer',data,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.answerReson = r.data
            that.showAnswerResult = true
          })
        })
      },
      answerModal(){
        this.showAnswerResult = false
        this.answerT = ''
        this.getHome();
      },
      getHome(){
        let that = this
        that.$api.post('/api/index/index',null,r =>{
        	that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.question = r.data.question
            that.draw_num = r.data.draw_num
            that.left_qus_num = r.data.left_qus_count
        	})
        })
      },
      saveModal(){
        this.showPrizeResult = false
      },
      goPlay(index){
        let that = this
        let data = {
          'pay_times':index
        }
        that.modalList = {list:[]}
        that.$parent.loadModal(true);
        that.$api.post('/api/index/lottery',data,r =>{
        	that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.isShow = true;
            that.modalList = r.data
            that.draw_num = r.data.draw_num
             setTimeout(function(){
                that.isShow=false;
               that.showPrizeResult = true
             },2000);
        	})
        })
      },
      fastLogin(){
        let that = this
        that.$parent.loadModal(true);
        let data = {
          'mobile':this.$route.query.mobile
        }
        that.$api.post('/api/user/fast_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            localStorage.setItem('is_white',r.data.is_white)
            this.getHome();
            this.getTrafficRewards();
          }else{
            that.$utils.alertText(r.msg,80);
            this.$router.push({path:'subscribe_v2'})
          }
        })
      },
      getTrafficRewards(){
        let that = this
        that.$api.post('/api/traffic_reward/index',null,r =>{
          that.$parent.returnCode(r,function(){
            let rewards = r.data && r.data.list ? r.data.list : []
            const mobile = localStorage.getItem('mobile') || 'current-user'
            const storageKey = 'claim-reward-modal:last-shown:' + mobile
            const lastShownAt = Number(localStorage.getItem(storageKey)) || 0
            const now = Date.now()
            if (rewards.length && (now - lastShownAt >= 24 * 60 * 60 * 1000 || lastShownAt > now)) {
              that.showTrafficRewardDialog = true
              localStorage.setItem(storageKey, String(now))
            }
          })
        })
      },
      closeTrafficReward(){
        this.showTrafficRewardDialog = false
      },
      goTrafficRewardList(){
        this.showTrafficRewardDialog = false
        this.$router.push({path:'/trafficReward'})
      }

	}
}
</script>
<style scoped>
  .answer-result-overlay{position:fixed;inset:0;z-index:1002;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:0.65rem 0.2rem;overflow-y:auto;}
  .answer-result-mask{position:fixed;inset:0;background:rgba(0,0,0,.78);}
  .answer-result-layout{position:relative;width:91vw;max-width:6.9rem;margin:auto;transform:translateY(0.2rem);}
  .answer-result-panel{position:relative;width:100%;aspect-ratio:1025 / 990;background:url(../../static/images/answer_pop_up/pop_up_bg.png) no-repeat center center;background-size:100% 100%;}
  .answer-result-art{display:block;width:100%;height:auto;}
  .answer-result-title{position:absolute;top:-0.4rem;left:50%;width:85.8%;height:1.02rem;display:flex;align-items:center;justify-content:center;background:url(../../static/images/answer_pop_up/pop_up_title_bg.png) no-repeat center center;background-size:100% 100%;transform:translateX(-50%);}
  .answer-result-title span{padding:0 0.12rem 0.06rem;color:#fff;font-family:Atom-sans-bold;font-size:0.63rem;font-style:italic;line-height:1;white-space:nowrap;-webkit-text-stroke:0.025rem #2168ff;text-shadow:0.025rem 0.025rem 0 #142b93,-0.025rem -0.025rem 0 #142b93,0 0 0.1rem #fff;}
  .answer-result-details{position:absolute;top:49.5%;right:0;bottom:0;left:0;display:flex;flex-direction:column;align-items:center;padding:0.16rem 0.22rem 0.46rem;color:#fff;font-family:Atom-sans;font-size:0.29rem;line-height:1.24;text-align:center;}
  .answer-result-details p{width:100%;margin:0.12rem 0 0;overflow-wrap:anywhere;}
  .answer-result-details strong{font-weight:700;}
  .answer-result-details .answer-correct{color:#a6ff38;}
  .answer-result-details .answer-wrong{color:#ff347b;}
  .answer-result-details em{color:#ffea2d;font-family:Atom-sans-bold;font-size:0.44rem;font-style:normal;font-weight:700;}
  .answer-result-confirm{width:57%;aspect-ratio:577 / 202;margin-top:auto;padding:0;border:0;color:#fff;background:url(../../static/images/answer_pop_up/btn_bg.png) no-repeat center center;background-size:100% 100%;font-family:Atom-sans-bold;font-size:0.38rem;font-style:italic;cursor:pointer;}
  .answer-result-confirm span{display:block;line-height:1.1;transform:translateY(0.035rem);}
  .answer-result-close{display:block;width:0.72rem;height:0.72rem;margin:0.38rem auto 0;padding:0;border:0;background:none;cursor:pointer;}
  .answer-result-close img{display:block;width:100%;height:100%;}
  .answer-result-burmese .answer-result-title span{font-size:0.51rem;}
  .answer-result-burmese .answer-result-details{font-size:0.26rem;}
  .answer-result-burmese .answer-result-confirm{font-size:0.3rem;}
  @media (max-width:360px){
    .answer-result-details{font-size:0.26rem;}
    .answer-result-title span{font-size:0.55rem;}
  }

  .prize-result-panel{position:relative;width:100%;aspect-ratio:1025 / 1150;background:url(../../static/images/prize_pop_up/pop_up_bg.png) no-repeat center center;background-size:100% 100%;}
  .prize-result-art{display:block;width:100%;height:auto;}
  .prize-result-title{background-image:url(../../static/images/prize_pop_up/pop_up_title_bg.png);}
  .prize-result-details{position:absolute;top:42%;right:0;bottom:0;left:0;display:flex;flex-direction:column;align-items:center;padding:0.14rem 0.25rem 0.35rem;color:#fff;font-family:Atom-sans;text-align:center;}
  .prize-result-details p{width:100%;margin:0;font-size:0.28rem;line-height:1.4;overflow-wrap:anywhere;}
  .prize-result-details p strong{color:#19e9ee;font-weight:700;}
  .prize-result-reward{width:75%;min-height:1.18rem;max-height:1.65rem;margin-top:0.28rem;padding:0.1rem 0.18rem;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0.02rem;overflow-y:auto;background:url(../../static/images/prize_pop_up/prize_txt.png) no-repeat center center;background-size:100% 100%;color:#ffe422;font-family:Atom-sans-bold;font-size:0.42rem;font-weight:700;line-height:1.1;overflow-wrap:anywhere;}
  .prize-result-reward span{display:block;width:100%;}
  .prize-result-empty{color:#06e4b1;font-size:0.55rem;}
  .prize-result-confirm{margin-top:auto;background-image:url(../../static/images/prize_pop_up/btn_bg.png);font-size:0.34rem;}
  .prize-result-burmese .prize-result-details p{font-size:0.25rem;}
  .prize-result-burmese .prize-result-reward{font-size:0.32rem;}
  .prize-result-burmese .prize-result-confirm{font-size:0.28rem;}
  .buy-popup-panel{position:relative;width:100%;aspect-ratio:1025 / 990;background:url(../../static/images/buy_pop_up/buy_pop_up_bg.png) no-repeat center center;background-size:100% 100%;}
  .buy-popup-art{display:block;width:100%;height:auto;}
  .buy-popup-title{background-image:url(../../static/images/buy_pop_up/pop_up_title_bg.png);}
  .buy-popup-title span{font-size:0.51rem;}
  .buy-popup-details{position:absolute;top:49%;right:0;bottom:0;left:0;display:flex;flex-direction:column;align-items:center;padding:0.18rem 0.22rem 0.46rem;color:#fff;font-family:Atom-sans;font-size:0.28rem;line-height:1.35;text-align:center;}
  .buy-popup-details p{width:100%;margin:0;overflow-wrap:anywhere;}
  .buy-popup-details strong{color:#a9ff3d;font-weight:700;}
  .buy-popup-confirm{margin-top:auto;background-image:url(../../static/images/buy_pop_up/btn_bg.png);font-size:0.34rem;}
  .buy-popup-confirm:disabled{opacity:.7;}
  .buy-otp-panel{aspect-ratio:1025 / 1150;}
  .buy-otp-panel .buy-popup-title span{font-size:0.63rem;}
  .buy-otp-details{position:absolute;top:43%;right:0;bottom:0;left:0;display:flex;flex-direction:column;align-items:center;padding:0.15rem 0.2rem 0.36rem;color:#fff;font-family:Atom-sans;text-align:center;}
  .buy-otp-details p{width:100%;margin:0;font-size:0.28rem;line-height:1.35;overflow-wrap:anywhere;}
  .buy-otp-details p strong{color:#1debf2;}
  .buy-otp-field{width:75%;min-height:1.2rem;margin-top:0.4rem;padding:0.08rem 0.08rem 0.08rem 0.25rem;display:flex;align-items:center;border:0.025rem solid #2838c8;border-radius:1rem;background:#060d36;}
  .buy-otp-field input{min-width:0;flex:1;border:0;background:none;color:#fff;font-family:Atom-sans-bold;font-size:0.46rem;letter-spacing:0.08rem;text-align:center;}
  .buy-otp-field input::placeholder{color:#fff;opacity:1;}
  .buy-otp-seconds,.buy-otp-resend{width:1.13rem;height:0.93rem;flex:none;display:flex;align-items:center;justify-content:center;border:0;border-radius:0.65rem;background:url(../../static/images/buy_pop_up/sec_bg.png) no-repeat center center;background-size:100% 100%;color:#fff;font-family:Atom-sans-bold;font-size:0.36rem;}
  .buy-otp-resend{padding:0;background:none;cursor:pointer;}
  .buy-otp-resend img{display:block;width:100%;height:100%;}
  .buy-otp-confirm{font-size:0.36rem;}
  .buy-popup-burmese .buy-popup-title span{font-size:0.39rem;}
  .buy-popup-burmese .buy-popup-details,.buy-popup-burmese .buy-otp-details p{font-size:0.25rem;}
  .buy-popup-burmese .buy-popup-confirm{font-size:0.28rem;}

  .modal-content2{text-align:center;position:absolute;top:50%;left:50%;margin-top:-0.1rem;border-radius:0.08rem;margin-left: -45%;width: 90%;}
  .modal-content2 img{border-radius:0.2rem;width:100%;}

  .index-page{min-height:100vh;padding:0 0 2.25rem;background:#080e36 url(../../static/images/index/main_bg.jpg) no-repeat center top;background-size:100% 100%;color:#fff;}
  .index-header{height:2.32rem;display:flex;justify-content:center;align-items:flex-start;padding-top:0.72rem;}
  .index-header a{display:block;width:1.48rem;}
  .index-header img{display:block;width:100%;}
  .index-main{width:91.2%;max-width:7rem;margin:0 auto;}
  .claim-banner{width:100%;margin:0 0 0.2rem;cursor:pointer;}
  .claim-banner img{display:block;width:100%;border-radius:0.18rem;}

  .quiz-section{margin-bottom:1.12rem;}
  .quiz-card{width:100%;min-height:9.84rem;padding:0.2rem 0.22rem 0.3rem;display:flex;flex-direction:column;align-items:center;background:url(../../static/images/index/quiz_bg.png) no-repeat center center;background-size:100% 100%;}
  .quiz-picture{width:100%;height:3.05rem;overflow:hidden;border-radius:0.22rem;}
  .quiz-picture img{display:block;width:100%;height:100%;object-fit:cover;}
  .quiz-title{width:94%;min-height:1.13rem;padding:0.17rem 0.05rem 0.08rem;display:flex;align-items:center;justify-content:center;font-size:0.29rem;line-height:1.35;text-align:center;overflow-wrap:anywhere;}
  .quiz-answers{width:76%;display:flex;flex-direction:column;gap:0.1rem;margin-top:0.18rem;}
  .quiz-answer{width:100%;min-height:0.88rem;padding:0.1rem 0.24rem;border:0;color:#fff;background:url(../../static/images/index/ans_normal.png) no-repeat center center;background-size:100% 100%;font-family:Atom-sans;font-size:0.35rem;line-height:1.15;text-align:center;overflow-wrap:anywhere;}
  .quiz-answer.active{background-image:url(../../static/images/index/ans_select.png);}
  .quiz-check-row{width:100%;margin-top:auto;padding-top:0.36rem;display:flex;justify-content:space-between;align-items:flex-end;}
  .quiz-scroll-arrow{width:0.38rem;height:0.43rem;object-fit:contain;margin:0 0.18rem 0.13rem;}
  .quiz-check{width:3.36rem;min-height:1.28rem;padding:0 0.2rem;display:flex;align-items:center;justify-content:center;border:0;color:#fff;background:url(../../static/images/index/let_check_btn.png) no-repeat center center;background-size:100% 100%;font-family:Atom-sans-bold;font-style:italic;font-size:0.35rem;white-space:nowrap;}
  .quiz-check-label{display:flex;align-items:center;justify-content:center;line-height:1.15;transform:translateY(0.04rem);}
  .quiz-check img{width:0.18rem;height:0.3rem;margin-left:0.08rem;object-fit:contain;}
  .index-summary{width:100%;min-height:1.45rem;margin-top:0.17rem;padding:0.2rem 0.16rem;display:flex;gap:0.16rem;align-items:center;justify-content:space-between;background:url(../../static/images/index/ques_amt_buy_bg.png) no-repeat center center;background-size:100% 100%;}
  .summary-count{width:49%;min-height:0.83rem;padding:0.05rem 0.18rem;display:flex;align-items:center;justify-content:center;gap:0.07rem;background:url(../../static/images/index/question_left.png) no-repeat center center;background-size:100% 100%;color:#fff;font-family:Atom-sans;font-size:0.25rem;line-height:1.12;text-align:center;}
  .summary-count strong{color:#a6ff3c;font-size:0.3rem;}
  .summary-count:only-child{width:100%;}
  .summary-link{width:49%;min-height:0.83rem;padding:0.05rem 0.09rem 0.05rem 0.17rem;display:flex;align-items:center;justify-content:space-between;gap:0.04rem;border:0;color:#fff;background:url(../../static/images/index/more_questions.png) no-repeat center center;background-size:100% 100%;font-family:Atom-sans;font-size:0.25rem;line-height:1.1;text-align:center;}
  .summary-link span{flex:1;}
  .summary-link img{width:0.6rem;height:0.6rem;object-fit:contain;}

  .lottery-section{padding-top:0.01rem;scroll-margin-top:0.28rem;}
  .lottery-board{width:100%;min-height:12.15rem;position:relative;padding:1.48rem 0.18rem 0.35rem;display:flex;flex-direction:column;align-items:center;background:url(../../static/images/index/lucky_boxes_bg.png) no-repeat center center;background-size:100% 100%;}
  .lottery-heading{position:absolute;top:-0.46rem;left:50%;width:50%;height:auto;transform:translateX(-50%);}
  .lottery-heading-text{min-height:1.18rem;display:flex;align-items:center;justify-content:center;color:#fff;font-size:0.53rem;font-weight:700;line-height:1.15;text-align:center;text-shadow:0 0 0.28rem #8653ff;}
  .lottery-description{width:100%;min-height:1.15rem;padding:0.17rem 0.08rem;background:url(../../static/images/index/pick_box_txt_bg.png) no-repeat center center;background-size:100% 100%;font-family:Atom-sans;font-size:0.28rem;line-height:1.25;text-align:center;}
  .lottery-description strong{color:#aeff39;font-weight:700;}
  .lottery-grid{width:100%;margin-top:0.28rem;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));column-gap:0.02rem;row-gap:0.23rem;}
  .lottery-item{display:flex;flex-direction:column;align-items:center;}
  .lottery-box{width:1.63rem;height:1.49rem;border:0;background:none;}
  .lottery-box img{display:block;width:100%;height:100%;object-fit:contain;transform-origin:50% 85%;animation:lottery-box-shake 4.8s ease-in-out infinite;}
  .lottery-item:nth-child(2) .lottery-box img{animation-delay:-1.1s;}
  .lottery-item:nth-child(3) .lottery-box img{animation-delay:-2.2s;}
  .lottery-item:nth-child(4) .lottery-box img{animation-delay:-3.3s;}
  .lottery-item:nth-child(5) .lottery-box img{animation-delay:-4.4s;}
  .lottery-item:nth-child(6) .lottery-box img{animation-delay:-0.55s;}
  .lottery-item:nth-child(7) .lottery-box img{animation-delay:-1.65s;}
  .lottery-item:nth-child(8) .lottery-box img{animation-delay:-2.75s;}
  .lottery-item:nth-child(9) .lottery-box img{animation-delay:-3.85s;}
  @keyframes lottery-box-shake{
    0%,6%,24%,100%{transform:translate(0,0) rotate(0);}
    9%{transform:translate(-0.035rem,-0.015rem) rotate(-5deg);}
    12%{transform:translate(0.035rem,-0.035rem) rotate(5deg);}
    15%{transform:translate(-0.025rem,-0.01rem) rotate(-4deg);}
    18%{transform:translate(0.025rem,-0.025rem) rotate(3deg);}
    21%{transform:translate(-0.01rem,0) rotate(-1deg);}
  }
  @media (prefers-reduced-motion: reduce){
    .lottery-box img{animation:none;}
  }
  .lottery-pick{position:relative;width:1.52rem;height:0.67rem;margin-top:0.02rem;padding:0;border:0;color:#fff;background:url(../../static/images/index/pick.png) no-repeat center center;background-size:100% 100%;font-family:Atom-sans-bold;font-size:0.27rem;line-height:1.1;}
  .lottery-pick span{position:absolute;top:59%;left:0;box-sizing:border-box;width:100%;padding:0 0.04rem;text-align:center;transform:translateY(-50%);}
  .lottery-random{width:3.55rem;min-height:1.26rem;margin-top:auto;padding:0 0.16rem;display:flex;align-items:center;justify-content:center;border:0;color:#fff;background:url('../../static/images/index/random_pick_btn_bg.png') no-repeat center center;background-size:100% 100%;font-family:Atom-sans-bold;font-style:italic;font-size:0.31rem;}
  .lottery-random span{line-height:1.15;transform:translateY(0.04rem);}
  .lottery-summary{margin-top:0.2rem;}

  .claim-reward-modal{z-index:1001;}
  .claim-reward-panel{position:absolute;top:50%;left:50%;width:84%;max-width:7.5rem;transform:translate(-50%,-50%);}
  .claim-reward-panel-bg{display:block;width:100%;height:auto;}
  .claim-reward-copy{position:absolute;top:57%;left:5.3%;width:89.4%;}
  .claim-reward-copy img{display:block;width:100%;}
  .claim-reward-copy p{position:absolute;top:50%;left:50%;width:84%;margin:0;color:#fff;font-family:Atom-sans;font-size:0.27rem;font-weight:700;line-height:1.25;text-align:center;transform:translate(-50%,-50%);}
  .claim-reward-action{position:absolute;top:81%;left:50%;width:48%;padding:0;border:0;background:none;cursor:pointer;transform:translateX(-50%);}
  .claim-reward-action img{display:block;width:100%;}
  .claim-reward-action span{position:absolute;top:50%;left:50%;width:100%;color:#101623;font-family:Atom-sans;font-size:0.32rem;font-weight:700;line-height:1;white-space:nowrap;transform:translate(-50%,-50%);}
  .claim-reward-close{position:absolute;top:101%;left:50%;width:0.62rem;padding:0;border:0;background:none;cursor:pointer;transform:translateX(-50%);}
  .claim-reward-close img{display:block;width:100%;}

  @media (min-width:481px){
    .index-page{box-shadow:0 0 0 100vmax #0d123b;}
  }

</style>



// WEBPACK FOOTER //
// src/page/index.vue